import { useSyncExternalStore } from 'react';
import { entityProjection } from '../entity-projection';
import type { WorkspaceCollection } from '../entity-types';

const EMPTY: readonly WorkspaceCollection[] = Object.freeze([]);

export function useWorkspaceCollections(): readonly WorkspaceCollection[] {
  return useSyncExternalStore(
    (l) => entityProjection.subscribe(l),
    () => entityProjection.getSnapshot().collections,
    () => EMPTY,
  );
}
